export function generateStats(arr) {
  let stats = {};
  stats[Object.keys(arr[0])[0]] = 0;
  stats[Object.keys(arr[0])[1]] = 0;
  for (let i = 0; i < arr.length; i++) {
    stats[Object.keys(arr[0])[0]] += arr[i][Object.keys(arr[0])[0]].length;
    stats[Object.keys(arr[0])[1]] += arr[i][Object.keys(arr[0])[1]].length;
  }
  return stats;
}